// Auto-generated subset of themes/Images.js: only the images that constants/constants.ts uses.
// Importing the full barrel here would pull every PNG in the app into any bundle
// that touches these constants (see the registration app's bundle size work).
/* eslint-disable global-require */
const images = {
  icAccountSettings: require('../images/lightModeIcon/ic-user-profile.png'),
  icAddNoteOption: require('../images/memberSearch/mobile/profileOptionModal/icAddNoteOption.png'),
  icBlock: require('../images/newIconSet/icBlock.png'),
  icDeleteTrash: require('../images/memberSearch/mobile/profileOptionModal/icDeleteTrash.png'),
  icEditReport: require('../images/icEditReport.png'),
  icFollowOption: require('../images/forum/menuOption/icFollowOption.png'),
  icFooterDiscover: require('../images/footer/icFooterDiscover.png'),
  icFooterDiscoverActive: require('../images/footer/icFooterDiscoverActive.png'),
  icFooterHome: require('../images/footer/icFooterHome.png'),
  icFooterHomeActive: require('../images/footer/icFooterHomeActive.png'),
  icFooterMsg: require('../images/footer/icFooterMsg.png'),
  icFooterMsgActive: require('../images/footer/icFooterMsgActive.png'),
  icFooterProspect: require('../images/footer/icFooterProspect.png'),
  icFooterProspectActive: require('../images/footer/icFooterProspectActive.png'),
  icFooterSetting: require('../images/footer/icFooterSetting.png'),
  icFooterSettingActive: require('../images/footer/icFooterSettingActive.png'),
  icHelpSupport: require('../images/menuSetting/modal/icHelpSupport.png'),
  icIgnoreOption: require('../images/forum/menuOption/icIgnoreOption.png'),
  icLegal: require('../images/menuSetting/menu/icLegal.png'),
  icLogOut: require('../images/menuSetting/modal/icLogOut.png'),
  icModerate: require('../images/chatRooms/chatRooms/icModerate.png'),
  icMyLists: require('../images/lightModeIcon/ic-list.png'),
  icNotificationSettings: require('../images/lightModeIcon/ic-bell-notification.png'),
  icPrivacySettings: require('../images/lightModeIcon/ic-lock-privacy.png'),
  icPrivateAlbum: require('../images/editProfile/mobile/icPrivateAlbum.png'),
  icPrivateConversation: require('../images/chatRooms/modal/icPrivateConversation.png'),
  icPublicAlbum: require('../images/editProfile/mobile/icPublicAlbum.png'),
  icReport: require('../images/newIconSet/icReport.png'),
  icReportChatRoom: require('../images/chatRooms/modal/icReportChatRoom.png'),
  icReportOption: require('../images/memberSearch/mobile/profileOptionModal/icReportOption.png'),
  icShare: require('../images/ic-share-upload.png'),
  icSubscriptions: require('../images/lightModeIcon/ic-purchases.png'),
  icTimeOut: require('../images/chatRooms/chatRooms/icTimeOut.png'),
  icTrash: require('../images/newIconSet/icBinTrash.png'),
  icUnFollowOption: require('../images/forum/menuOption/icUnfollow.png'),
  icW: require('../images/chatRooms/modal/icW.png'),
  upgradeImg2: require('../images/upgradeMember/mobile/upgradeImg2.jpg'),
  upgradeImg4: require('../images/upgradeMember/mobile/upgradeImg4.jpg'),
  upgradeImg6: require('../images/sexualImage/upgradeImg6.jpg'),
};

export default images;
